// --- Raccourcis de catégories ---
export const categoryShort: Record<string, string> = {
	'Gestion des Ressources Humaines': 'GRH',
	'Gestion de la relation client': 'GRC',
	'Gestion de la relation fournisseur': 'GRF',
	'Gestion des Produits/Services': 'GPS',
	'Gestion du Pilotage Opérationnel': 'GPO',
	Système: 'SYS',
};

// --- Couleurs des badges ---
export const categoryColors: Record<string, string> = {
	GRH: 'bg-blue-200 text-blue-800',
	GRC: 'bg-green-200 text-green-800',
	GRF: 'bg-purple-200 text-purple-800',
	GPS: 'bg-yellow-100 text-yellow-800',
	GPO: 'bg-pink-200 text-pink-800',
	SYS: 'bg-gray-200 text-gray-800',
};
